'use client';

import { useEffect } from 'react';
import { NotificationsBell } from '@/new_components/notifications/NotificationsBell';
import { CreditsPill } from '@/new_components/shared/CreditsPill';
import LandingSearch from '@/new_components/shared/LandingSearch';
import { cn } from '@/lib/utils';
import { useLocale } from '@/hooks/use-locale';
import { useScrollPosition } from '@/hooks/use-scroll-position';
import { useSettings } from '@/providers/settings-provider';

export function AppTopBar() {
  const { internalPathname } = useLocale();
  const { settings } = useSettings();
  const scrollPosition = useScrollPosition();
  const sticky = scrollPosition > settings.layouts.demo7.headerStickyOffset;
  useEffect(() => {
    if (sticky) document.body.setAttribute('data-sticky-header', 'on');
    else document.body.removeAttribute('data-sticky-header');
    return () => document.body.removeAttribute('data-sticky-header');
  }, [sticky]);

  return (
    <header
      className={cn(
        'fd-header sticky top-0 z-50 hidden h-(--header-height-default) w-full shrink-0 items-center gap-4 border-b border-[var(--fd-line)] px-6 transition-shadow lg:flex',
        sticky &&
          'shadow-[0_1px_0_0_var(--fd-line-2),0_8px_24px_-16px_rgba(14,14,12,0.12)]',
      )}
    >
      <div
        className={cn(
          'min-w-0 grow',
          internalPathname !== '/search' && 'max-w-[760px]',
        )}
      >
        <LandingSearch compact className="max-w-none" />
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-2 [&_button]:focus-visible:outline-none [&_button]:focus-visible:ring-2 [&_button]:focus-visible:ring-ring">
        <CreditsPill />
        <NotificationsBell />
      </div>
    </header>
  );
}
